// extracted by mini-css-extract-plugin
export default {"tag":"TemplatedTitle__tag___AJUjz"};